import { Link } from 'react-router-dom';
import { BodyMedium } from '@/components/typography';

interface SidebarItemProps {
    label: string;
    path: string;
    icon?: React.ReactNode;
    badge?: string;
    isActive?: boolean;
}

export const SidebarItem = ({ label, path, icon, badge, isActive }: SidebarItemProps) => {
    return (
        <Link
            to={path}
            className={`w-full h-9 px-3 py-1.5 rounded-lg flex justify-between items-center transition-colors ${
                isActive ? 'bg-primary/10' : 'bg-transparent hover:bg-white/5'
            }`}
        >
            <div className="flex items-center gap-4">
                {icon && (
                    <div className="w-5 h-5 flex justify-center items-center">
                        {icon}
                    </div>
                )}
                <BodyMedium className={isActive ? 'text-primary' : 'text-white/80'}>
                    {label}
                </BodyMedium>
            </div>
            {badge && (
                <div className="px-2 py-1 bg-primary rounded-full">
                    <span className="text-gray-900 text-xs font-medium font-outfit leading-4">
                        {badge}
                    </span>
                </div>
            )}
        </Link>
    );
};